module.exports = __webpack_public_path__ + "img/btn_share@3x.9d165af0.png";